module.exports = __webpack_public_path__ + "static/media/Hair_1_pink.f34096c3.svg";